import http from "./http_common";

class ConsultationService {
  queryString(payload) {
    const QueryString = Object.keys(payload).map((key) => (key && payload[key] && key + "=" + payload[key])).join('&');
    return QueryString;
  }

  ICDData(values) {
    const queryString = this.queryString(values);
    return http.get(`/common-icd-codes/list?${queryString}`);
  }

  LabTest(values) {
    return http.get(`/LabTestsAndScans/list/filter?name=${values}&pageNo=${1}&pageSize=${40}`);
  }

  LabTestsMdm(values) {
    const queryString = this.queryString(values);
    return http.get(`/LabInfoMdm/list/filter?labCode=DZA4401049&${queryString}`);
  }

  presOrdLabMdm(payload){
    const queryString = this.queryString(payload);
    return http.get(`/LabInfoMdm/list/filter?${queryString}`);
  }

  getPrescriptions(payload) {
    var queryString = Object.keys(payload)
      .map((key) => payload[key] && key + "=" + payload[key])
      .join("&");
    return http.get(`/consultation/list/filter?${queryString}`);
  }

  ConsultationNotes(payload) {
    return http.post(`/consultation/save`, payload);
  }

  EndConsultation(payload) {
    return http.post(`/consultation/endConsultation`, payload);
  }

  updateConsultation(payload) {
    return http.put(`/consultation/update/${payload.id}`, payload);
  }

  SharePrescriptionAPI(payload) {
    return http.post(`/consultation/share-Eprescription`, payload);
  }

  SharePharmaLabAPI(payload) {
    return http.post(`/consultation/share-Eprescription/pharmaandlab`, payload);
  }

  UpdatePatientDetailsInConsultation(payload) {
    return http.put(`/patient/update/patientdetails`, payload);
  }

  specialityForm(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/templates/list/filter?${queryString}`);
  }

  specialityMappedTemplates(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/templateSpeciality/list/filter?${queryString}`);
  }

  fetchSuggestiveData(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/DiagnosisSymptomMaster/list/filter?${queryString}`);
  }

  fetchSymptomsList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/Suggestion/listSuggestion?${queryString}`);
  }

  fetchECGgraph(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/labTestOrderResult/ecgLatestDoc/list/filter?${queryString}`);
  }

  fetchStethescopeReports(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/documentForVisit/list/filter?${queryString}`);
  }

  saveSteth(payload) {
    return http.post(`documentForVisit/save`, payload);
  }

  deleteStethReport(payload) {
    return http.delete('/documentForVisit/delete', { data: payload });
  }

  getCallJoinedData(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/ConsultationJoiningHistory/list/filter?${queryString}`);
  }

  getDentalFormData(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/consultationSpecialityToothDetails/list/filter?${queryString}`);
  }

}

export default new ConsultationService();